// extracted by mini-css-extract-plugin
export default {"generatePass":"GeneratePass_generatePass__YeDuS","button":"GeneratePass_button__bz9dG","register":"GeneratePass_register__q7sCn"};